import React, { useState, useRef, useEffect } from "react";
import "./NotificationCard.css";

interface NotificationCardProps {
  id: string;
  title: string;
  message: string;
  createdAt: string;
  imageUrl: string | null;
  cardIndex: number;
  onClick: () => void;
}

const NotificationCard: React.FC<NotificationCardProps> = ({
  title,
  message,
  createdAt,
  imageUrl,
  cardIndex,
  onClick,
}) => {
  const [isExpanded, setIsExpanded] = useState(false);
  const [needsExpansion, setNeedsExpansion] = useState(false);
  const [showImageFullscreen, setShowImageFullscreen] = useState(false);
  const contentRef = useRef<HTMLDivElement>(null);

  // Calcular se a notificação foi criada nas últimas 24 horas
  const notificationDate = new Date(createdAt);
  const now = new Date();
  const timeDifference = now.getTime() - notificationDate.getTime();
  const hoursDifference = timeDifference / (1000 * 60 * 60);
  const isRecent = hoursDifference <= 24;

  useEffect(() => {
    // Verificar se o conteúdo excede 5 linhas
    const checkHeight = () => {
      if (contentRef.current) {
        const lineHeight = parseFloat(
          getComputedStyle(contentRef.current).lineHeight
        );
        const maxHeight = lineHeight * 5;
        const actualHeight = contentRef.current.scrollHeight;
        setNeedsExpansion(actualHeight > maxHeight + 5);
      }
    };

    setTimeout(checkHeight, 100);
  }, [message]);

  const handleToggle = (e: React.MouseEvent) => {
    e.stopPropagation();
    setIsExpanded(!isExpanded);
  };

  return (
    <div
      className={`notification-card notification-card-${
        (cardIndex % 4) + 1
      } ${isRecent ? "notification-recent" : ""}`}
      style={{ cursor: "default" }}
    >
      <div className="notification-header">
        <div className="notification-title-container">
          <h3 className="notification-title">{title}</h3>
          {isRecent && <span className="notification-new-badge">NOVO</span>}
        </div>
        <span className="notification-date">
          {notificationDate.toLocaleDateString("pt-BR", {
            day: "2-digit",
            month: "2-digit",
            year: "numeric",
          })}
        </span>
      </div>
      <div className="notification-content">
        {imageUrl && (
          <div 
            className="notification-image-preview"
            onClick={(e) => {
              e.stopPropagation();
              setShowImageFullscreen(true);
            }}
          >
            <img
              src={imageUrl}
              alt="Preview"
            />
          </div>
        )}
        <div
          ref={contentRef}
          className={`notification-message-text ${
            !isExpanded && needsExpansion
              ? "notification-message-collapsed"
              : ""
          }`}
          dangerouslySetInnerHTML={{ __html: message }}
        />
      </div>
      <div className="notification-footer">
        {needsExpansion && (
          <button
            className="notification-toggle-btn"
            onClick={handleToggle}
          >
            {isExpanded ? "Ver menos" : "Ver mais"}
          </button>
        )}
        <span className="notification-time">
          {notificationDate.toLocaleTimeString("pt-BR", {
            hour: "2-digit",
            minute: "2-digit",
          })}
        </span>
      </div>

      {/* Modal de imagem fullscreen */}
      {showImageFullscreen && imageUrl && (
        <div
          className="notification-image-fullscreen-overlay"
          onClick={() => setShowImageFullscreen(false)}
        >
          <button
            className="notification-image-fullscreen-close"
            onClick={() => setShowImageFullscreen(false)}
          >
            ✕
          </button>
          <img
            src={imageUrl}
            alt="Fullscreen"
            className="notification-image-fullscreen"
            onClick={(e) => e.stopPropagation()}
          />
        </div>
      )}
    </div>
  );
};

export default NotificationCard;
